export default __webpack_public_path__ + "static/media/blackGrid.bb578996.png";